<div class="w-full overflow-hidden">
  <shared-title class="flex justify-content-start ml-4 mt-4">
    {{ data ? 'Modificar' : 'Crear' }} tema
  </shared-title>
  <form [formGroup]="themeForm" (submit)="onSubmit()">
    <!-- inputs -->
    <mat-dialog-content class="w-full overflow-y-auto overflow-x-hidden">
      <div class="overflow-y-auto h-auto flex flex-column align-content-center">
        <div
          class="mt-1 w-full flex justify-content-around flex-wrap flex-row align-items-center">
          <!-- name -->
          <mat-form-field class="w-15rem" appearance="outline">
            <mat-label>Nombre del Tema</mat-label>
            <input matInput formControlName="name" />
            @if (themeForm.controls['name'].hasError('required')) {
              <mat-error>
                <small>Nombre es <strong>requerido</strong> </small>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <!-- row -->
        <div
          class="mt-1 w-full flex justify-content-around flex-wrap flex-row align-items-center">
          <!-- title -->
          <mat-form-field class="w-15rem" appearance="outline">
            <mat-label>Títulos de módulos</mat-label>
            <input
              matInput
              [ngxMatColorPicker]="pickerTitle"
              formControlName="title"
              readonly />
            <ngx-mat-color-toggle
              matSuffix
              [for]="pickerTitle"></ngx-mat-color-toggle>
            <ngx-mat-color-picker
              #pickerTitle
              [touchUi]="touchUi"
              [color]="color"></ngx-mat-color-picker>
            @if (themeForm.controls['title'].hasError('invalidHexColor')) {
              <mat-error>
                <small>Ingresa un <strong>hexadecimal </strong> valido. </small>
              </mat-error>
            } @else if (themeForm.controls['title'].hasError('required')) {
              <mat-error>
                <small>Color del titulo es <strong>requerido</strong> </small>
              </mat-error>
            }
          </mat-form-field>

          <!-- primary -->
          <mat-form-field class="w-15rem" appearance="outline">
            <mat-label>Fondo de barra superior</mat-label>
            <input
              matInput
              [ngxMatColorPicker]="pickerSub1"
              formControlName="primary"
              readonly />
            <ngx-mat-color-toggle
              matSuffix
              [for]="pickerSub1"></ngx-mat-color-toggle>
            <ngx-mat-color-picker
              #pickerSub1
              [touchUi]="touchUi"
              [color]="color"></ngx-mat-color-picker>

            @if (themeForm.controls['primary'].hasError('invalidHexColor')) {
              <mat-error>
                <small>Ingresa un <strong>hexadecimal </strong> valido. </small>
              </mat-error>
            } @else if (themeForm.controls['primary'].hasError('required')) {
              <mat-error>
                <small>Color del titulo es <strong>requerido</strong> </small>
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- row -->
        <div
          class="w-full flex justify-content-around flex-wrap flex-row align-items-center">
          <!-- accent -->
          <mat-form-field class="w-15rem" appearance="outline">
            <mat-label>Iconos de barra lateral</mat-label>
            <input
              matInput
              [ngxMatColorPicker]="pickerSub2"
              formControlName="accent"
              readonly />
            <ngx-mat-color-toggle
              matSuffix
              [for]="pickerSub2"></ngx-mat-color-toggle>
            <ngx-mat-color-picker
              #pickerSub2
              [touchUi]="touchUi"
              [color]="color"></ngx-mat-color-picker>

            @if (themeForm.controls['accent'].hasError('invalidHexColor')) {
              <mat-error>
                <small>Ingresa un <strong>hexadecimal </strong> valido. </small>
              </mat-error>
            } @else if (themeForm.controls['accent'].hasError('required')) {
              <mat-error>
                <small>Color del titulo es <strong>requerido</strong> </small>
              </mat-error>
            }
          </mat-form-field>

          <!-- warn -->
          <mat-form-field class="w-15rem" appearance="outline">
            <mat-label>Botones</mat-label>
            <input
              matInput
              [ngxMatColorPicker]="pickerSub3"
              formControlName="warn"
              readonly />
            <ngx-mat-color-toggle
              matSuffix
              [for]="pickerSub3"></ngx-mat-color-toggle>
            <ngx-mat-color-picker
              #pickerSub3
              [touchUi]="touchUi"
              [color]="color"></ngx-mat-color-picker>
            @if (themeForm.controls['warn'].hasError('invalidHexColor')) {
              <mat-error>
                <small>Ingresa un <strong>hexadecimal </strong> valido. </small>
              </mat-error>
            } @else if (themeForm.controls['warn'].hasError('required')) {
              <mat-error>
                <small>Color del titulo es <strong>requerido</strong> </small>
              </mat-error>
            }
          </mat-form-field>
        </div>

        <!-- row -->
        <div
          class="w-full flex justify-content-around flex-wrap flex-row align-items-center">
          <!-- General -->
          <mat-form-field class="w-15rem" appearance="outline">
            <mat-label>Letras de los módulos</mat-label>
            <input
              matInput
              [ngxMatColorPicker]="pickerGeneral"
              formControlName="general"
              readonly />
            <ngx-mat-color-toggle
              matSuffix
              [for]="pickerGeneral"></ngx-mat-color-toggle>
            <ngx-mat-color-picker
              #pickerGeneral
              [touchUi]="touchUi"
              [color]="color"></ngx-mat-color-picker>
            @if (themeForm.controls['general'].hasError('invalidHexColor')) {
              <mat-error>
                <small>Ingresa un <strong>hexadecimal </strong> valido. </small>
              </mat-error>
            } @else if (themeForm.controls['general'].hasError('required')) {
              <mat-error>
                <small>Color del titulo es <strong>requerido</strong> </small>
              </mat-error>
            }
          </mat-form-field>

          <!-- itemNavBar -->
          <mat-form-field class="w-15rem" appearance="outline">
            <mat-label>Ítems de la barra superior</mat-label>
            <input
              matInput
              [ngxMatColorPicker]="pickeritemNavBar"
              formControlName="itemNavBar"
              readonly />
            <ngx-mat-color-toggle
              matSuffix
              [for]="pickeritemNavBar"></ngx-mat-color-toggle>
            <ngx-mat-color-picker
              #pickeritemNavBar
              [touchUi]="touchUi"
              [color]="color"></ngx-mat-color-picker>
            @if (themeForm.controls['itemNavBar'].hasError('invalidHexColor')) {
              <mat-error>
                <small>Ingresa un <strong>hexadecimal </strong> valido. </small>
              </mat-error>
            } @else if (themeForm.controls['itemNavBar'].hasError('required')) {
              <mat-error>
                <small>Color del titulo es <strong>requerido</strong> </small>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <!-- controlers -->
    <div class="flex justify-content-evenly w-full mb-4">
      <shared-button mat-dialog-close [color]="'warn'" [icon]="'clear'"
        >Cancelar</shared-button
      >
      <shared-button
        [disabled]="!themeForm.valid"
        [color]="'accent'"
        [icon]="'save_alt'"
        [typeBtn]="'submit'"
        >Guardar</shared-button
      >
    </div>
  </form>
</div>
